"use strict";

import ScatterplotController from "./scatterplot.controller.js";

function scatterplot(){

    return{

        restrict: "E",
        scope: {
            name: "=",
            id: "=",
            chartIndex: "="
        },
        template: require("./scatterplot.html"),
        controller: ScatterplotController,
        controllerAs: "ctrl"

    }

}

export default angular
    .module("scatterplot.directive", [])
    .directive("scatterplot", scatterplot)
    .name;




// WEBPACK FOOTER //
// ./src/app/emxd-charts/scatterplot/scatterplot.directive.js